import { Entity } from './entity';
import { environment } from '../../environments/environment';

export class PageDrawing implements Entity {

    id: number;
    pageId: number;
    fabricCanvas: any;
    fabricObject: any;

    getEndpointName(): string {
        return environment.endpointUrls.pageDrawings;
    }
}
